import { Permission, PermissionName } from './permissionName';
import { isNotEmpty } from '../utils/object_utils';

/**
 * 権限管理インターフェース
 */
export interface IRole {
  roleId: string;
  permissions: Permission[];
}

/**
 * 権限管理クラス
 */
export class Role {
  private role: IRole;

  /**
   * コンストラクタ
   * @param role
   */
  constructor(role: IRole) {
    this.role = role;
  }

  /**
   * 権限チェック
   * @param permission
   * @param readWrite
   */
  public hasPermission(permission: PermissionName, readWrite?: boolean): boolean {
    if (!isNotEmpty(this.role?.permissions)) {
      return false;
    }
    return this.role?.permissions.some((p) => p.name === permission && (readWrite === undefined || p.readWrite === readWrite));
  }
}
